import VMasker from 'vanilla-masker';
import { removePhoneNumberCountryCode } from './phone-number-to-formatted-string.js';
const phoneNumberE164Pattern = '+19999999999';
const phoneNumberToE164 = (phoneNumber) => VMasker.toPattern(removePhoneNumberCountryCode(phoneNumber), phoneNumberE164Pattern);
export default phoneNumberToE164;
//# sourceMappingURL=phone-number-to-e164-string.js.map